import { DataBean } from "../DataBean";

export class CashRequestBudget extends DataBean {


    public async getCashRequestBudgetCatalog(idCashRequest:any,cashRequestDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCashRequestBudgetCatalog_Number_java.util.Date", [idCashRequest,cashRequestDate]);
    }

}